import _readOnlyError from "@babel/runtime/helpers/esm/readOnlyError";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import { Set } from 'immutable';
import ReduxRecord from './reduxRecord';
import t from '@instructure/quiz-i18n/format-message';
import { TEMPORARY_BANK_ID, CAN_EDIT } from '@instructure/quiz-common';
import { rule } from 'instructure-validations';
import { presenceMessage } from '@instructure/quiz-interactions';
import { getLatestQtiImportForParentWithType } from '../selectors/qtiImports';
export var Bank = /*#__PURE__*/function (_ReduxRecord) {
  function Bank() {
    _classCallCheck(this, Bank);
    return _callSuper(this, Bank, arguments);
  }
  _inherits(Bank, _ReduxRecord);
  return _createClass(Bank, [{
    key: "createdAt",
    value: function createdAt() {
      return new Date(this.get('createdAt'));
    }
  }, {
    key: "updatedAt",
    value: function updatedAt() {
      return new Date(this.get('updatedAt'));
    }
  }, {
    key: "lastUsed",
    value: function lastUsed() {
      var lastUsed = this.get('lastUsed');
      return lastUsed ? new Date(lastUsed) : null;
    }
  }, {
    key: "isLoaded",
    value: function isLoaded() {
      return this.id !== '0';
    }
  }, {
    key: "isTemporary",
    value: function isTemporary() {
      return this.id === TEMPORARY_BANK_ID;
    }
  }, {
    key: "getWorkingInstance",
    value: function getWorkingInstance() {
      var data = this.merge(this.getState().getIn(['modifications', 'banks', this.id]));
      return Bank.create(data);
    }
  }, {
    key: "hasModifications",
    value: function hasModifications() {
      return false;
    }
  }, {
    key: "canImport",
    value: function canImport() {
      return this.status === 'waiting' && this.entryCount === 0;
    }
  }, {
    key: "getLatestImport",
    value: function getLatestImport() {
      return getLatestQtiImportForParentWithType(this.getState(), this.id, 'Bank');
    }
  }, {
    key: "canEdit",
    value: function canEdit() {
      return this.permission === CAN_EDIT;
    }
  }], [{
    key: "validations",
    value: function validations() {
      return {
        title: [rule('presence', {
          message: presenceMessage(t('Bank name'))
        })]
      };
    }
  }]);
}(ReduxRecord({
  accountPermission: null,
  archived: false,
  bankEntries: Set(),
  createdAt: null,
  entryCount: 0,
  // item count + stimulus count
  filters: null,
  id: '0',
  itemEntryCount: 0,
  // item count only
  language: null,
  creator: '',
  permission: '',
  sharedCount: 0,
  status: null,
  title: '',
  updatedAt: null,
  lastUpdated: null,
  lastUsed: null
}));
export default Bank;